export default __webpack_public_path__ + "static/media/3.fe04bf08.jpg";